import { GridColumns } from '@mui/x-data-grid/models';
import React from 'react';

import { DeleteOutline, Edit } from '@mui/icons-material';
import { IconButton, Tooltip } from '@mui/material';
import { injectEntityList } from '../../../../../../../common/store/base/injectEntityList';
import { IEntityListStore } from '../../../../../../../common/store/interface/IEntityListStore';
import { IPerformerTypeSearch } from '../../../../../../../service/performer/type/IPerformerTypeSearch';
import { IProjectModel } from '../../../../../../../service/project/IProjectModel';
import { IUserSystemRoleModel } from '../../../../../../../service/systemRole/entity/IUserSystemRoleModel';
import { MultiLineText } from '../../../../../../design/dataTable/parts/fieldArea/MultiLineText';
import { DataTableRowDependency } from '../../../../../../design/dataTable/parts/rowDependency/DataTableRowDependency';
import { IDataTableRowsUI } from '../../../../../../design/dataTable/parts/rows/IDataTableRowsUI';
import { DataTableUI } from '../../../../../../design/dataTable/store/DataTableUI';
import { IDataTableUI } from '../../../../../../design/dataTable/store/IDataTableUI';
import { UserAdminRowsUI } from './rows/UserAdminRowsUI';
import { UserAdminDomain } from './UserAdminDomain';
import { UserAdminModel } from './UserAdminModel';

export class UserAdminUI
  extends DataTableUI<UserAdminModel, IPerformerTypeSearch>
  implements IDataTableUI<UserAdminModel, IPerformerTypeSearch> {
  constructor(
    public domain: UserAdminDomain,
    rows: IDataTableRowsUI<UserAdminModel, IPerformerTypeSearch> | null,
    public systemRoleId: IEntityListStore<IUserSystemRoleModel> = injectEntityList<IUserSystemRoleModel>([]),
    public projects: IEntityListStore<IProjectModel> = injectEntityList<IProjectModel>([]),
  ) {
    super(domain, rows);
    this.rows = rows || new UserAdminRowsUI(this);
  }
  setDomainId(): string {
    return 'settings/user/entity';
  }
  async getColumns(): Promise<GridColumns> {
    this.setActionColumn()
    return [
      {
        headerName: this.i18n.translate('settingsUser.login'),
        field: 'login',
        flex: 1,
        renderCell: (params: { value?: string }) => {
          if (this.domain.contextMenuDomain.ui.activeRow.entity?.login === 'admin') {
            this.domain.setNoDeletePermission();
          } else {
            this.domain.setPermissions();
          }
          return <MultiLineText words={this.rows.searchTerm.value} value={params.value || ''} />;
        },
      },
      {
        headerName: this.i18n.translate('settingsUser.email'),
        field: 'email',
        flex: 1,
        renderCell: (params: { value?: string }) => {
          return <MultiLineText words={this.rows.searchTerm.value} value={params.value || ''} />;
        },
      },
      {
        headerName: this.i18n.translate('settingsUser.fio'),
        field: 'displayName',
        flex: 1,
        renderCell: (params: { value?: string }) => {
          return <MultiLineText words={this.rows.searchTerm.value} value={params.value || ''} />;
        },
      },
      {
        headerName: this.i18n.translate('settingsUser.role'),
        field: 'systemRoleId',
        flex: 1,
        valueGetter: (params) => {
          const systemRoleId = this.domain.ui.rows.getFieldValueAsString('systemRoleId', params.value);

          return systemRoleId;
        },
        renderCell: (params: { value?: string; row: any }) => {
          const fieldValues = this.domain.ui.rows.getFieldValueAsDependencies('systemRoleId', params.row.systemRoleId);
          return (
            <DataTableRowDependency
              onClick={() => {
                // this.domain.onLinkAction(params.row.categoryId, '/settings/tag/category');
              }}
              getTextValue={(item: any) => item.name}
              searchTerm={this.rows.searchTerm.value}
              values={fieldValues}
            />
          );
        },
      },

      {
        headerName: this.i18n.translate('settingsUser.creationType'),
        field: 'sourceType',
        flex: 1,
        valueGetter: (params) => {
          const value = (params.value ?? '').toString();
          if (value === 'internal') {
            return this.i18n.translate('settingsUser.creationTypeLocal');
          }
          if (value === 'activeDirectory') {
            return 'Active Directory';
          }
          if (value === 'sso') {
            return 'SSO';
          }
          return value;
        },
        renderCell: (params: { value?: string }) => {
          return <MultiLineText words={this.rows.searchTerm.value} value={params.value || ''} />;
        },
      },
      {
        headerName: this.i18n.translate('settingsUser.active'),
        field: 'isActive',
        type: 'boolean',
        flex: 1,
        headerAlign: 'left',
        align: 'left'
      },
    ];
  }

  async setActionColumn() {
    const actionColumn = this.actionColumnSettings.value
    actionColumn.actionItem = {
      field: 'action',
      headerName: this.i18n.translate('settingsUser.action'),
      flex: 0.3,
      minWidth: 60,
      headerAlign: 'left',
      align: 'left',
      sortable: false,
      disableColumnMenu: true,
      renderCell: (row: any) => {
        return (
          <>
            {row?.row?.sourceType !== 'activeDirectory' && < div style={{
              display: 'flex',
              justifyContent: 'space-between',
              minWidth: 40,
              maxWidth: 60,
            }
            }>
              <Tooltip title={this.i18n.translate('phrases.edit')}>
                <IconButton
                  disabled={!this.isCanEdit.value}
                  // data-cy={`actions-button-for-${row.row.name}`} //todo data-cy
                  onClick={(event) => this.domain.contextMenuDomain.onEditRow(row)}
                  style={{ marginRight: '8px' }}
                >
                  <Edit sx={{ cursor: 'pointer', fontSize: '20px' }} />
                </IconButton>
              </Tooltip>
              {
                row?.row?.login !== 'admin' && row?.row?.sourceType !== 'sso' &&
                <Tooltip title={this.i18n.translate('phrases.delete')}>
                  <IconButton
                    disabled={!this.isCanDelete.value}
                    // data-cy={`actions-button-for-${row.row.name}`} //todo data-cy
                    onClick={(event) => this.domain.contextMenuDomain.onDeleteRow(row)}
                  >
                    <DeleteOutline sx={{ cursor: 'pointer', fontSize: '20px' }} />
                  </IconButton>
                </Tooltip>
              }
            </div >}
          </>

        );
      },

    }
    this.actionColumnSettings.setValue(actionColumn)
  }
}
